import { render, staticRenderFns } from "./DocumentRequestForm.vue?vue&type=template&id=6a598e44"
import script from "./DocumentRequestForm.vue?vue&type=script&lang=js"
export * from "./DocumentRequestForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentRequestForm.vue?vue&type=style&index=0&id=6a598e44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports